<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MXFynT/tc-custom/9780547344973.jpg?1718079115969" alt="This image is the cover for the book Farewell, My Only One"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Farewell, My Only One
      </h1>
      <p class="bookDescription body article font2">
        <b>A novel that brings to life one of the great romances of all time. “Evokes in gritty and poetic detail the streets of twelfth-century Paris.” —<i>The New York Times Book Review</i></b><br/><br/>In the early twelfth century, William reaches Paris full of hope and without a penny. There, on the same day, he meets the two people who will dominate his life: young Heloise, with whom he immediately falls in love, and Abelard, the world-renowned philosopher. Through the eyes of William, we follow every turn in the greatest love story of the Middle Ages. We witness, in harrowing and lush descriptions, the scandal of the famous theologian falling for his educated and charming student; their flight and secret marriage; the barbaric revenge of the girl’s uncle; their years of separation; the writing of the famous letters; and finally the demise of a broken Abelard, whose books have been burned, a man who finds his ultimate solace in the thought of the woman who has never ceased to love him.<br/><br/>Antoine Audouard brings literary grace to a story that is palpably infused with sensuality, conflict, and intellectual ferment. <i>Farewell, My Only One</i> is intelligent and bawdy, philosophical and romantic—a universal story of star-crossed lovers.<br/><br/><b>“This is an elegantly written novel, refreshing in its bawdy portrayal of religious figures and intellectually stimulating in its rigorous treatment of the theological discourse of the time.” —<i>Publishers Weekly</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Antoine Audouard, Euan Cameron
      </h2>
      
      <p class="authorDescription body article">The son of a well-known French writer and journalist, ANTOINE AUDOUARD was born in 1956 and had very early success with three novels in rapid succession before gave up writing for commercial publishing. Adieu, Mon Unique (Farewell, My Only One) is his first novel in nineteen years.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (hmhbooks.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5e2e4e85